const HeartRemoveIcon = /*#__PURE__*/ [
  ["path", { d: "M13.5893 19.9677C12.6399 20.6776 11.3601 20.6776 10.4107 19.9677C7.58942 17.858 2 13.0348 2 8.69444C2 5.82563 4.10526 3.5 7 3.5C8.5 3.5 10 4 12 6C14 4 15.5 3.5 17 3.5C19.8947 3.5 22 5.82563 22 8.69444C22 9.45389 21.8289 10.2281 21.5314 11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16 13.5L18.5 16M18.5 16L21 18.5M18.5 16L21 13.5M18.5 16L16 18.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export { HeartRemoveIcon as default };
//# sourceMappingURL=HeartRemoveIcon.js.map
